import { ApiGroup } from '../types/ApiTypes';

export const PointBalanceAPI: ApiGroup = {
    pagedList: {
        title: '사용자 잔액 목록 조회',
        method: 'POST',
        url: '/PointBalance/PagedList',
        paramz: {},
    },
};
